import { toast } from "sonner";

const APP_URL = window.location.origin;

export const shareAchievement = async (achievement, streak, t) => {
  const text = achievement
    ? `${achievement.name} - ${achievement.description} | LumiFit`
    : `${streak?.current_streak || 0} day streak on LumiFit!`;

  const shareData = {
    title: "LumiFit Achievement",
    text: text,
    url: APP_URL,
  };

  if (navigator.share) {
    try {
      await navigator.share(shareData);
    } catch (err) {
      if (err.name !== "AbortError") {
        fallbackCopy(text, t);
      }
    }
  } else {
    fallbackCopy(text, t);
  }
};

const fallbackCopy = async (text, t) => {
  try {
    await navigator.clipboard.writeText(text + " " + APP_URL);
    toast.success(t ? t("share.copied") : "Copied to clipboard!");
  } catch {
    toast.error("Failed to copy");
  }
};

export const shareStreak = async (streak, t) => {
  const text = `I'm on a ${streak?.current_streak || 0} day streak on LumiFit! Physical: ${streak?.total_physical_completed || 0} | Cognitive: ${streak?.total_cognitive_completed || 0}`;

  if (navigator.share) {
    try {
      await navigator.share({ title: "LumiFit Streak", text, url: APP_URL });
    } catch (err) {
      if (err.name !== "AbortError") fallbackCopy(text, t);
    }
  } else {
    fallbackCopy(text, t);
  }
};

/** Share to a specific social platform. Falls back to Web Share API or clipboard. */
export const shareToSocial = (platform, text) => {
  const encoded = encodeURIComponent(text);
  const url = encodeURIComponent(APP_URL);

  const urls = {
    twitter: `https://x.com/intent/tweet?text=${encoded}&url=${url}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encoded}`,
    instagram: null, // Instagram has no web share intent — copy + toast
  };

  if (platform === "instagram") {
    navigator.clipboard
      .writeText(`${text} ${APP_URL}`)
      .then(() => toast.success("Copied! Paste it in your Instagram story or post."))
      .catch(() => toast.error("Failed to copy"));
    return;
  }

  const target = urls[platform];
  if (target) {
    window.open(target, "_blank", "noopener,noreferrer,width=600,height=400");
  }
};
